"use client";
import { createSplitProps } from "../../utils/create-split-props.js";
import { ark } from "../factory.js";
import { ProgressProvider } from "./use-progress-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/progress/progress-root-provider.tsx
var splitRootProviderProps = createSplitProps();
var ProgressRootProvider = forwardRef((props, ref) => {
	const [{ value: progress }, localProps] = splitRootProviderProps(props, ["value"]);
	const mergedProps = mergeProps(progress.getRootProps(), localProps);
	return /* @__PURE__ */ jsx(ProgressProvider, {
		value: progress,
		children: /* @__PURE__ */ jsx(ark.div, {
			...mergedProps,
			ref
		})
	});
});
ProgressRootProvider.displayName = "ProgressRootProvider";
//#endregion
export { ProgressRootProvider };
